import { ErrorMessage, Field, Label } from "@/components/catalyst/fieldset";
import { UseFormRegisterReturn, FieldError } from "react-hook-form";
import { Input } from "@/components/catalyst/input";

type PasswordFieldProps = {
  register: UseFormRegisterReturn<"password">;
  error?: FieldError;
  disabled?: boolean;
  invalid?: boolean;
  autoComplete?: string;
  testId?: string;
};

export function PasswordField({
  register,
  error,
  disabled = false,
  invalid,
  autoComplete,
  testId,
}: PasswordFieldProps) {
  return (
    <Field>
      <Label>Password</Label>
      <Input
        {...register}
        type="password"
        disabled={disabled}
        invalid={invalid ?? !!error}
        autoComplete={autoComplete}
        data-testid={testId}
      />
      {error?.message && <ErrorMessage>{error.message}</ErrorMessage>}
    </Field>
  );
}
